import React from 'react';

type RoleCardProps = {
  onClick?: () => void;
  iconSrc: string;
  iconAlt?: string;
  title: React.ReactNode;
  description?: React.ReactNode;
  style?: React.CSSProperties;
};

export const RoleCard: React.FC<RoleCardProps> = ({ onClick, iconSrc, iconAlt = '', title, description, style }) => {
  const handleMouseEnter = (e: React.MouseEvent<HTMLDivElement>) => {
    const el = e.currentTarget;
    el.style.transform = 'translateY(-2px)';
    el.style.boxShadow = '0px 8px 20px rgba(17, 61, 123, 0.15)';
  };

  const handleMouseLeave = (e: React.MouseEvent<HTMLDivElement>) => {
    const el = e.currentTarget;
    el.style.transform = 'translateY(0)';
    el.style.boxShadow = 'none';
  };

  return (
    <div
      onClick={onClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{
        width: 220,
        height: 200,
        padding: 24,
        background: 'white',
        borderRadius: 24,
        outline: '1px #E5E7EB solid',
        outlineOffset: '-1px',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        display: 'inline-flex',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        ...style,
      }}
    >
      <div
        style={{
          width: 40,
          height: 40,
          position: 'relative',
          overflow: 'hidden',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <img src={iconSrc} alt={iconAlt} style={{ width: 32, height: 32 }} />
      </div>
      <div style={{ alignSelf: 'stretch', display: 'flex', flexDirection: 'column', gap: 8 }}>
        <div style={{ color: 'black', fontSize: 14, fontFamily: 'var(--ep-font-avenir)', fontWeight: 700 }}>
          {title}
        </div>
        {description && (
          <div style={{ color: '#4A5565', fontSize: 12, fontFamily: 'var(--ep-font-avenir)' }}>{description}</div>
        )}
      </div>
    </div>
  );
};

export default RoleCard;
